<script lang="ts">
  import Icon from './Icon.svelte'

  interface Props {
    icon: string
    label: string
    size?: number
    tone?: 'default' | 'accent' | 'danger'
    onclick?: (event: MouseEvent) => void
  }
  const { icon, label, size = 20, tone = 'default', onclick }: Props = $props()
</script>

<button class="icon-button {tone}" aria-label={label} title={label} {onclick}>
  <Icon name={icon} {size} />
</button>

<style>
  .icon-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: none;
    border-radius: var(--radius);
    background: transparent;
    color: var(--fg-muted);
    transition: background var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease);
  }
  .icon-button:hover {
    background: var(--surface-2);
    color: var(--fg);
  }
  .accent {
    color: var(--accent);
  }
  .danger {
    color: var(--danger);
  }
</style>
